import { AuthGuard } from '@/modules/auth/router/auth.guard';

export default [
    {
        name: 'alerts',
        path: '/notifications',
        component: () => import(/* webpackChunkName: "alert" */ '@/modules/alert/views/Alerts.vue'),
        meta: { title: 'Notifications' },
        props: true,
        beforeEnter: AuthGuard,
    },
    // {
    //     name: 'alerts:create',
    //     path: '/alerts/create',
    //     component: () => import(/* webpackChunkName: "alert" */ '@/modules/alert/views/ConfigureAlert.vue'),
    //     meta: { title: 'Create Alert', feature: 'alerts' },
    //     props: true,
    //     beforeEnter: AuthGuard,
    // },
    // {
    //     name: 'alerts:edit',
    //     path: '/alerts/:id',
    //     component: () => import(/* webpackChunkName: "alert" */ '@/modules/alert/views/ConfigureAlert.vue'),
    //     meta: { title: 'Update Alert', feature: 'alerts' },
    //     props: true,
    //     beforeEnter: AuthGuard,
    // },
];
